import React from 'react';
import Box from 'components/elements/Box';
import H1 from 'components/elements/h1';
import colors from 'styles/themes/colors';
import Button from 'components/elements/button';
import { ReactComponent as Close } from 'icons/icon-close.svg';
import {
  Bold,
  CloseButton,
  CloseButtonContainer,
  GridContainer,
  GridItem,
  ImgContainer,
  StyledLink,
} from '../styles';
import generalSettingsImg from './installationInstructions/generalSettings.png';
import trustOptionImg from './installationInstructions/trustOption.png';
import urlImg from './installationInstructions/url.png';
import vpnManagementImg from './installationInstructions/vpnManagement.png';
import wifiImg from './installationInstructions/wifi.png';
import untrustedImg from './installationInstructions/untrusted.png';

interface IProps {
  close: () => void;
  isMobileScreen: boolean;
}

const InstallationInstructions: React.FC<IProps> = ({
  close,
  isMobileScreen,
}) => {
  return (
    <Box py={3} px={4}>
      <Button display="block" marginLeft="auto" onClick={close}>
        <Close />
      </Button>
      <H1 color={colors.ShadowBlack} fontSize={4} my={0} marginBottom={4}>
        Installation Instructions
      </H1>
      <GridContainer isMobileScreen={isMobileScreen}>
        <GridItem>{`When you first open the Notifier app after installed, you will get a notification that the developer of the app isn't trusted on your device as below.`}</GridItem>
        <GridItem>
          <ImgContainer>
            <img
              src={untrustedImg}
              alt="untrusted image"
              width="270px"
              height="212px"
            />
          </ImgContainer>
        </GridItem>
        <GridItem>
          <Bold>{`To use the app, please complete the following steps:`}</Bold>
        </GridItem>
        <GridItem></GridItem>
        <GridItem>
          {`1. Tap `}
          <Bold>{`“Cancel” `}</Bold>
          {`to dismiss this message.`}
        </GridItem>
        <GridItem></GridItem>
        <GridItem>
          {`2. Tap `}
          <Bold>{`Settings > General > VPN & Device Management.`}</Bold>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <img
              src={generalSettingsImg}
              alt="general settings image"
              width="270px"
              height="375px"
            ></img>
          </ImgContainer>
        </GridItem>
        <GridItem>
          {`3. Tap `}
          <Bold>{`“WARNER MUSIC GROUP CORP."`}</Bold>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <img
              src={vpnManagementImg}
              alt="vpn management image"
              width="270px"
              height="118px"
            ></img>
          </ImgContainer>
        </GridItem>
        <GridItem>
          {`4. Tap `}
          <Bold>{`“Trust” `}</Bold> {`button and confirm your choice.`}
        </GridItem>
        <GridItem>
          <ImgContainer>
            <img
              src={trustOptionImg}
              alt="trust option image"
              width="270px"
              height="199px"
            ></img>
          </ImgContainer>
        </GridItem>
        <GridItem>{`5. Then you can now go back and start using the app.`}</GridItem>
        <GridItem></GridItem>
        <GridItem>
          <Bold>{`Note: `}</Bold>
          {`If you're behind a `}
          <Bold>{`firewall app `}</Bold>
          {`on your iPhone, make sure that it's configured to allow connections to `}
          <StyledLink href={`https://ppq.apple.com`}>
            {`https://ppq.apple.com.`}
          </StyledLink>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <img src={urlImg} alt="url image" width="270px" height="61px"></img>
          </ImgContainer>
        </GridItem>
        <GridItem>
          {`You must be `}
          <Bold>{`connected to the Internet `}</Bold>
          {`to verify the app developer's certificate when establishing trust. If you aren't connected to the Internet when you trust an app, the device displays "Not Verified" instead. To use the app, connect to the Internet and tap the Verify App button.`}
        </GridItem>
        <GridItem>
          <ImgContainer>
            <img src={wifiImg} alt="wifi img" width="270px" height="81px"></img>
          </ImgContainer>
        </GridItem>
      </GridContainer>
      <CloseButtonContainer>
        <CloseButton onClick={close}>Close</CloseButton>
      </CloseButtonContainer>
    </Box>
  );
};

export default InstallationInstructions;
